// removed by extract-text-webpack-plugin
module.exports = {"overlay":"SessionTimeoutWarning__overlay___18F94","confirmButton":"SessionTimeoutWarning__confirmButton___kya1Y"};